import { AnchorLinkIcon, ButtonIcon, PlatfiCarousel } from 'platfi-ui-components';

import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';

import StepContent from 'modules/Onboarding/components/StepContent/StepContent';

import styles from './Carousel.scss';

const OnboardingCarousel = (props) => {
  const {
    completeOnboarding,
    goToPreviousSlide,
    goToNextSlide,
    setSlideIndex,
    slideIndex,
    slidesConfig,
  } = props;

  return (
    <div styleName="a-carousel">
      <PlatfiCarousel
        afterSlide={setSlideIndex}
        cellAlign="center"
        dragging={false}
        ease="easeOut"
        slideIndex={slideIndex}
        speed={500}
        swiping={false}
        withoutControls
      >
        {slidesConfig.map((slide, index) => {
          const isLast = index >= slidesConfig.length - 1;
          const { content, nextButtonAction, nextButtonLabel, ...rest } = slide;

          const defaultButtonLabel = isLast ? 'Go to dashboard' : 'Next';
          const onClick = () => {
            if (nextButtonAction) {
              nextButtonAction();
              return;
            }

            if (isLast) {
              completeOnboarding();
            }
            goToNextSlide();
          };

          return (
            <div key={index} styleName="a-carousel__card">
              <StepContent {...rest}>{content && content(goToNextSlide)}</StepContent>

              <div styleName="a-carousel__controls">
                {index > 0 && (
                  <AnchorLinkIcon
                    className="u-pull-left"
                    icon="arrow_left"
                    onClick={goToPreviousSlide}
                    secondary
                    small
                  >
                    Previous
                  </AnchorLinkIcon>
                )}

                <ButtonIcon
                  className="u-pull-right"
                  icon="arrow_right"
                  iconRight
                  label={nextButtonLabel || defaultButtonLabel}
                  onClick={onClick}
                  primary
                  small
                />
              </div>
            </div>
          );
        })}
      </PlatfiCarousel>
    </div>
  );
};

OnboardingCarousel.propTypes = {
  completeOnboarding: PropTypes.func.isRequired,
  goToPreviousSlide: PropTypes.func.isRequired,
  goToNextSlide: PropTypes.func.isRequired,
  setSlideIndex: PropTypes.func.isRequired,
  slideIndex: PropTypes.number.isRequired,
  slidesConfig: PropTypes.array.isRequired,
};

export default CSSModules(OnboardingCarousel, styles, { allowMultiple: true });
